<template>
  <DsfFormControlBox
    class="ds-date-picker"
    :owner="_self"
    :block-class="{ 'ds-error-border': errors.length > 0 }"
  >
    <template v-slot:simple>
      <span :title="getShowContent() | proxy(formatter)">{{getShowContent() | proxy(formatter)}}</span>
      <slot name="error">
        <div
          v-if="errors.length > 0"
          class="ds-error-text"
        >
          {{ errorsMsg }}
        </div>
      </slot>
    </template>
    <template v-slot:content>
      <ds-date-picker
        v-if="!readOnly"
        v-model="value2"
        :type="pickerType"
        :period-type="chooseType"
        :format="format"
        :value-format="valueFormat"
        :picker-options="mPicker || pickerOptions"
        :disabled="disabled"
        :clearable="clearable"
        popperClass="ds-date-picker-panel"
        :default-time="['00:00:00', '23:59:59']"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
      >
      </ds-date-picker>
      <!--只读状态只显示div-->
      <div
        v-else-if="readOnly"
        class="ds-form-readonly"
      >
        <span :title="getShowContent() | proxy(formatter)">{{
          getShowContent() | proxy(formatter)
        }}</span>
      </div>
      <slot name="error">
        <div
          v-if="errors.length > 0"
          class="ds-error-text"
        >
          {{ errorsMsg }}
        </div>
      </slot>
    </template>
  </DsfFormControlBox>
</template>
<script>
import dateMixin from "./dateMixin";
import { createDatePicker } from "./date-picker";

const ElDatePicker = ELEMENT.DatePicker;
const DsDatePicker = createDatePicker(ElDatePicker);

export default dsf.component({
  name: "DsfPeriodIntervalPicker",
  mixins: [$mixins.formControl, dateMixin],
  ctrlCaption: "季年旬区间",
  components: {
    DsDatePicker,
  },
  props: {
    chooseType: {
      type: String,
      default: "MD",
    },
    value: {
      type: Object,
      default() {
        return {
          sdate: "",
          edate: "",
        };
      },
    },
    defaultTime: {
      type: [String, Array],
      default() {
        return ["00:00:00", "23:59:59"];
      },
    },
    // 是否显示清除按钮
    clearable: {
      type: Boolean,
      default: true,
    },
    //用于二次开发的 pickerOptions
    mPicker: {
      type: Object,
      required: false,
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("date-interval-meta-data");
      },
    },
  },
  created() {
    this.initValue(this.value);
  },
  data() {
    return {
      // 显示格式(因为该组件显示格式唯一，所以通过i18n控制。ps: 这里的格式只是方便统一取值并非正真显示的文本)
      formats: {
        HY: "yyyy-MM",
        SS: "yyyy-MM",
        MD: "yyyy-MM-dd",
      },
      // formats: {
      //   zh_CN: {
      //     HY: "yyyy年M半年",
      //     SS: "yyyy年第M季度",
      //     MD: "yyyy年MM月dd旬",
      //   },
      //   en_US: {
      //     HY: "yyyy-MM",
      //     SS: "yyyy-MM",
      //     MD: "yyyy-MM-dd",
      //   },
      // },
      valueFormats: {
        HY: "yyyy-MM-dd HH:mm:ss",
        SS: "yyyy-MM-dd HH:mm:ss",
        MD: "yyyy-MM-dd HH:mm:ss",
      },
      val: this.value,
      value2: null,
    };
  },
  watch: {
    value(to, ov) {
      this.initValue(to);
    },
    value2(value) {
      let [sdate, edate] = value;
      const { sdate: sdate2, edate: edate2 } = this.value || {};
      if (edate) {
        edate = this.handleEndDate(true, edate);
      }
      if (sdate2 === sdate && edate2 === edate) {
        return;
      }
      this.emitValueChange({
        sdate,
        edate,
      });
    },
  },
  computed: {
    format() {
      return this.formats[this.chooseType];
    },
    valueFormat() {
      return this.valueFormats[this.chooseType];
    },
    pickerType() {
      if (this.chooseType == "MD") {
        return "daterange";
      }
      return "monthrange";
    },
  },
  methods: {
    initValue(v) {
      let { sdate = "", edate = "" } = v || {};
      if (sdate) {
        sdate = dsf.date.format(sdate.replace(/\-/g, "/"), "yyyy-mm-dd hh:ii:ss");
      }
      if (edate) {
        edate = this.handleEndDate(false, edate);
        edate = dsf.date.format(edate.replace(/\-/g, "/"), "yyyy-mm-dd hh:ii:ss");
      }
      this.value2 = [sdate, edate];
    },
    /**
     * @description: 范围选择重新计算最后日期（比如季度选择2021第一季度到第二季度组件正确返回为2021-1-1至2021-6-30， 但现在返回为2021-1-1至2021-4-1）
     * @param {Boolean} isV2ToV  value2计算value, 否则反之
     * @param {Date || string || number} edate 转换的时间
     * @return {Date string}
     */
    handleEndDate(isV2ToV, edate) {
      let mapping = {
        MD: { 1: 10, 11: 20, 21: 0 },
        SS: { 1: 3, 4: 6, 7: 9, 10: 12 },
        HY: { 1: 6, 7: 12 },
      };
      const endDate = new Date(edate);
      const currentYear = endDate.getFullYear();
      const currentMonth = endDate.getMonth() + 1;
      const currentDay = endDate.getDate();
      let edate1 = "";
      if (isV2ToV) {
        const m = mapping[this.chooseType];
        if (this.chooseType === "MD") {
          const day = m[currentDay];
          edate1 = new Date(currentYear, day === 0 ? currentMonth : currentMonth - 1, day, 23, 59, 59);
        } else {
          edate1 = new Date(currentYear, m[currentMonth], 0, 23, 59, 59);
        }
      } else {
        const m = Object.entries(mapping[this.chooseType]).reduce((initValue, [key, value]) => {
          initValue[value] = key;
          return initValue;
        }, {});
        if (this.chooseType === "MD") {
          const day = _.inRange(currentDay, 1, 11) ? 1 : _.inRange(currentDay, 11, 21) ? 11 : 21;
          edate1 = new Date(currentYear, currentMonth - 1, day);
        } else {
          edate1 = new Date(currentYear, m[currentMonth] - 1, 1);
        }
      }
      return dsf.date.format(edate1, "yyyy-mm-dd hh:ii:ss");
    },
  },
});
</script>
